import { render, staticRenderFns } from "./CorruptedThumbnail.vue?vue&type=template&id=c4487e40"
import script from "./CorruptedThumbnail.vue?vue&type=script&lang=js"
export * from "./CorruptedThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports